<template>
  <div>
    <section class="blocked_users">
      <div class="blocked_users_content">
        <div class="blocked_users_content__center">
          <div class="block_header">
            <h2>{{ getTranslations.home_users_blocked_users_title }}</h2>
            <p>{{ getTranslations.home_users_blocked_users_description }}</p>
          </div>
        </div>
      </div>
    </section>
    <user-list :is-modal="false">
      <template slot="content">
        <virtual-list v-if="getBlockedUsers.length"
                      :data-key="'username'"
                      :items="getProps()"
                      :wrapperType="'favorite_user'"
                      :remain="10"
                      :estimated="150"/>
        <div v-else class="profile__block__content profile__block__content--empty-state">
          <img src="static/images/block_user.svg" alt="">
          <h1>{{ getTranslations.home_users_blocked_users_empty_state_text }}</h1>
        </div>
      </template>
    </user-list>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import UserList from '@/components/home/shared/GenericList';
import FavoriteUser from '@/components/home/users/FavoriteUser';
import VirtualList from '@/components/home/shared/VirtualScrollList';

export default {
  name: 'blocked-users',
  components: {
    UserList,
    FavoriteUser,
    VirtualList,
  },
  mounted() {
    this.fetchBlockedUsers();
  },
  methods: {
    ...mapActions('users', [
      'fetchBlockedUsers',
    ]),
    getProps() {
      return this.getBlockedUsers
        .map(user => ({ ...user, isBlocked: true }));
    },
  },
  computed: {
    ...mapGetters('users', [
      'getBlockedUsers',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/profile/BlockedUsers.vue